import config from 'config';
import { authHeader, handleResponse } from '@/_helpers';

export const whitelistService = {
  getIps,
  addIp,
  updateIp,
  removeIp,
  restoreIp,
};

function getIps() {
  const requestOptions = { method: 'GET', headers: authHeader() };
  return fetch(`${config.apiUrl}/whitelist`, requestOptions).then(handleResponse);
}

function addIp(ip, comment) {
  const body = {
    ip,
    comment,
  };
  const requestOptions = { method: 'POST', headers: authHeader(), body: JSON.stringify(body) };
  return fetch(`${config.apiUrl}/whitelist`, requestOptions).then(handleResponse);
}

function updateIp(id, ip, comment) {
  const body = {
    ip,
    comment,
  };
  const requestOptions = { method: 'PUT', headers: authHeader(), body: JSON.stringify(body) };
  return fetch(`${config.apiUrl}/whitelist/${id}`, requestOptions).then(handleResponse);
}

function removeIp(id) {
  const requestOptions = { method: 'DELETE', headers: authHeader() };
  return fetch(`${config.apiUrl}/whitelist/${id}/remove`, requestOptions).then(handleResponse);
}

function restoreIp(id) {
  const requestOptions = { method: 'POST', headers: authHeader() };
  return fetch(`${config.apiUrl}/whitelist/${id}/restore`, requestOptions).then(handleResponse);
}
